<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="checkIn">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            自选配入住管理
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <Search :searchForm='searchForm' :searchData='searchData' v-on:getList='getList' ref="search">
                        <template slot="button">
                            <el-button :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                            <el-button :disabled='disabledEdit' @click="handleEdit">编辑</el-button>
                            <el-button :disabled='disabledIn'  @click="dialogFormVisible = true">入住</el-button>
                            <el-button :disabled='disabledType'  @click="updataTypeBefore()">正式入住</el-button>
                            <el-button :disabled='disabledRoomChange'  @click="handleRoomChange">转房</el-button>
                            <el-button :disabled='disabledSettlement' @click="dialogSettleTime=true">退住结算</el-button>
                            <el-button :disabled='disabledDetail' @click="detail">详情</el-button>
                        </template>
                        <template slot="daterange">
                            <Daterange :startTime="searchForm.startTime" :endTime="searchForm.endTime" @dataChange='dataChange'></Daterange>
                        </template>
                    </Search>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>


            <div>
                <template>

                    <el-table :data="tableData" :height="th" v-loading="loading" border style="width: 100%;" highlight-current-row @row-click='rowClick'>

                        <el-table-column prop="elderlyName" label="老人姓名" width="100"></el-table-column>

                        <el-table-column prop="liveAddress" label="床位号" width="150"></el-table-column>

                        <el-table-column prop="durationPlan" label="预住时常(天)" width="120"></el-table-column>

                        <el-table-column prop="priceMonth"  label="原月费用/元"  width="120"></el-table-column>

                        <el-table-column prop="priceMonthDeduction"  label="折后月费用/元"  width="120"></el-table-column>
                        
                        <!-- <el-table-column prop="preferentialPrice"  label="优惠金额/元"  width="120"></el-table-column> -->

                        <el-table-column prop="needVerify"  label="审核状态" width="120">
                            <template slot-scope="scope">
                                <el-tag type="info"  v-show="scope.row.needVerify==0" effect="plain">无需审核</el-tag>
                                <div v-show="scope.row.needVerify==1">
                                    <el-tag type="primary"  v-show="scope.row.auditResult==0" effect="plain">未审核</el-tag>
                                    <el-tag type="success"  v-show="scope.row.auditResult==1" effect="plain">已通过</el-tag>
                                    <template>
                                        <el-popover
                                            placement='right'
                                            title="备注"
                                            width="200"
                                            trigger="hover"
                                            :content="scope.row.noPassCause?scope.row.noPassCause:'无备注'">
                                            <el-tag type="danger"  slot="reference"  v-show="scope.row.auditResult==2" effect="plain">未通过</el-tag>
                                        </el-popover>
                                    </template>
                                </div>
                            </template>
                        </el-table-column>


                        
                        <el-table-column prop="cutBalance"  label="消费总金额(元)" width="140"></el-table-column>


                        <el-table-column
                                prop="type"
                                width="120"
                                label="入住类型">
                            <template slot-scope="scope">
                                <el-tag type="success"  v-show="scope.row.type==0" effect="plain">正式入住</el-tag>
                                <el-tag  v-show="scope.row.type==1&&scope.row.status!=1" effect="plain">试住</el-tag>
                                <el-tag type="warning" v-show="scope.row.type==2" effect="plain">预约入住</el-tag>
                                <!-- <el-popconfirm title="是否设为正式入住？" @confirm='updataType(scope.row)'>
                                    <el-tag v-show="scope.row.type==1&&scope.row.status==1" slot="reference" effect="plain">试住</el-tag>
                                </el-popconfirm> -->
                                <el-popover
                                    placement="right"
                                    width="160"
                                    title="提示"
                                    trigger="hover">
                                    <p>{{'是否设为正式入住？'}}</p>
                                    <div style="text-align: right; margin: 0">
                                        <el-button type="primary" size="mini" @click="updataType(scope.row)">确定</el-button>
                                    </div>
                                    <el-tag v-show="scope.row.type==1&&scope.row.status==1" slot="reference" effect="plain">试住</el-tag>
                                </el-popover>
                            </template>
                        </el-table-column>


                        <el-table-column
                                prop="status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column>

                        <el-table-column prop="balance"  label="余额(元)" width="80"></el-table-column>

                        <el-table-column prop="beginTimePlan" :formatter="formatterTime1" label="预计入住时间" width="120"></el-table-column>

                        <el-table-column prop="endTimePlan" :formatter="formatterTime1" label="预计退住时间" width="120"></el-table-column>

                        <el-table-column prop="beginTime" :formatter="formatterTime" label="实际入住时间" width="180"></el-table-column>

                        <!-- <el-table-column prop="deductionEndTime" :formatter="formatterTime1" label="折扣结束时间" width="120"></el-table-column> -->

                        <!-- <el-table-column prop="preferentialEndTime" :formatter="formatterTime1" label="优惠到期时间" width="120"></el-table-column> -->

                        <el-table-column prop="createTime" :formatter="formatterTime" width="180" label="登记时间"></el-table-column>

                        

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）
                        </div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </template>
            </div>
            <!-- 转房 -->
            <el-dialog title="转房" :visible.sync="dialogRoomChange" width="650px">
                <el-alert title="转房床位价格和之前床位价格相同" type="warning" style="margin-bottom: 20px;"> </el-alert>
                <el-form :model="roomChangeForm" label-position="top">
                    <el-form-item label="转房床位">
                        <el-cascader
                            v-model="roomChangeForm.newChangeBerthCode"
                            placeholder="请选择床号"
                            :options="listBerthRC" :props="props" style="width:60%">
                            <template slot-scope="{ node, data }">
                                <span v-if="!node.isLeaf"> {{ data.buildingName }} - </span>
                                <span>{{ data.number }}</span>
                            </template>
                        </el-cascader>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" v-model="roomChangeForm.remarks" placeholder="请输入转房备注" rows="3" style="width:100%"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogRoomChange = false">取 消</el-button>
                    <el-button type="primary" :loading="roomChangeSubmitLoading"  @click="roomChangeSubmit">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 入住点击设置时间 -->
            <el-dialog title="入住时间" :visible.sync="dialogFormVisible" width="450px" custom-class='checkinTime'>
                <el-form :model="form" label-position="top">
                    <el-form-item>
                        <el-date-picker
                        v-model="checkinTime"
                        type="datetime"
                        placeholder="选择日期时间"
                        :picker-options="pickerOptions"
                        style="width:100%"
                        value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="CheckinTimeSubmit">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 入住前明细 -->
            <el-dialog title="入住并扣费" :visible.sync="checkinVisible" width="800px">
                <div style="height:50vh;overflow: auto;">
                    <div class="checkinCharge">本月收费开始日期：{{today}} <span style="font-size:14px;color:#999">（收取当天费用）</span></div>
                    <div class="checkinCharge">本月收费到期日期：{{lastDayOfMonth}}</div>
                    <div class="checkinCharge">原月收费金额：{{checkInfo.priceMonth}} 元</div>
                    <div class="checkinCharge">折后收费金额：{{priceMonthDeduction}} 元</div>
                    <div class="checkinCharge">优惠券：
                        <div class="checkinCharge" v-for="(item,i) in checkinCoupon" :key="i">
                            <span>{{i+1}}、{{item.coupons.name}}：{{item.couponMoney}} 元</span> 
                        </div>
                        <span v-if="checkinCoupon.length==0">无</span>
                    </div>
                    <div class="checkinCharge">本月扣费自选配项目：
                        <div class="checkinCharge" v-for="(item,i) in checkinAutomatchFeeRelsList" :key="i">
                            <span>{{i+1}}、本月{{item.institutionFeeName}}费用：{{item.institutionFeePriceMonth}} 元</span>
                        </div>
                        <span v-if="checkinAutomatchFeeRelsList.length==0">无</span>
                    </div>
                    <div class="checkinCharge">本月应收金额：{{sumPriceCharge}} 元
                        <div style="font-size:14px;color:#999;padding-top:5px">本月应收金额 =（折后收费金额 - 优惠金额）/ 当月天数 *（本月收费到期日期 - 本月收费开始日期）</div>
                    </div>
                    <div class="checkinCharge">一次性固定费用：{{checkInfo.fixedFee}} 元</div>
                    
                    <div class="checkinCharge">抹零金额：<span v-show="!cutPriceInputShow"> {{cutPrice}} </span> 
                        <el-input-number v-show="cutPriceInputShow" v-model="cutPrice" :min='0' :max="9.99" :precision="2" :controls='false' @change="cutPriceInputShow=!cutPriceInputShow" class="inputMoneyNumber" size="small" style="width:80px">
                        </el-input-number> 元
                        <el-button type="text" size="small" @click="cutPriceInputShow=!cutPriceInputShow" v-show="!cutPriceInputShow">修改</el-button><span style="font-size:14px;color:#999">（最高抹零小于10元）</span>
                    </div>
                    <div class="checkinCharge" style="color:#ff2200">本次月扣费总费用：{{DoubleAdd(sumPriceCharge,checkInfo.fixedFee-parseFloat(cutPrice))}} 元
                        <div style="font-size:14px;color:#999;padding-top:5px">本次月扣费总费用 = 本月应收金额 + 一次性固定费用 - 抹零金额</div>
                    </div>
                    <div class="checkinCharge" style="color:#ff2200">老人余额：{{checkInfo.balance}} 元</div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="checkinVisible = false">取 消</el-button>
                    <el-button type="primary"  :loading="checkinSubmitLoading" @click="checkinSubmit">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 退住时间选择 -->
            <el-dialog title="退住时间" :visible.sync="dialogSettleTime" width="450px" custom-class='checkinTime'>
                <el-date-picker
                    v-model="settleTime"
                    type="datetime"
                    placeholder="选择日期时间"
                    :picker-options="pickerOptionsSettle"
                    style="width:100%"
                    value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogSettleTime = false">取 消</el-button>
                    <el-button type="primary" @click="settlefucBefore">确 定</el-button>
                </div>
            </el-dialog>
            <el-dialog title='结算明细(退费)' :visible.sync="settleDialog" class="dialog" width='1200px' top="5vh" :close-on-click-modal='false'>
                <el-tabs v-model="activeName" type="card" class="eltabs">
                    <el-tab-pane label="结算详情" name="1">
                        <div>
                            <div class="checkinCharge">原月收费金额：{{checkInfo.priceMonth}} 元</div>
                            <div class="checkinCharge">折后收费金额：{{priceMonthDeduction}} 元</div>
                            <div class="checkinCharge">优惠券：
                                <span v-if="checkinCouponDTOList.length==0">无</span>
                                <div v-else class="checkinCharge" v-for="(item,i) in checkinCouponDTOList" :key="i">
                                    <span>{{i+1}}、{{item.coupons.name}}：{{item.couponMoney}} 元 ({{timefilter(item.endTime)}}到期)</span> 
                                </div>
                            </div>
                            <div class="checkinCharge">结算退费日期：{{today}} 至 {{lastDayOfMonth}} (不含当日费用)</div>
                            <div class="checkinCharge">本月应退费总金额：{{(sumPriceSettle-parseFloat(settleForm.todayPrice?settleForm.todayPrice:0)).toFixed(2)}} 元
                                <!-- <el-popover
                                    placement="right"
                                    width="300"
                                    trigger="click">
                                    <span>额外费用包含：</span>
                                    <div style="color:#999;padding-left: 0px;" class="checkinCharge" v-for="(item,i) in checkinUnfixedMoneyDTOList" :key="i">
                                        <span>{{i+1}}、{{item.name}}：{{item.thisMonth}} 元</span> 
                                    </div>
                                    <el-button type="text" size="small" slot="reference">详情</el-button>
                                </el-popover> -->
                            </div>
                            <div class="checkinCharge">老人余额：{{balance}} 元</div>
                            <div class="checkinCharge">预交金：{{deposit}} 元</div>
                            <div class="checkinCharge">备用金：{{imprest}} 元</div>
                            <div class="checkinCharge" style="color:#ff2200">退款后余额：{{ (sumPrice-parseFloat(settleForm.todayPrice?settleForm.todayPrice:0)).toFixed(2)}} 元<span style="font-size:14px;color:#ff2200;">（负数需补交费用）</span>
                                <div style="font-size:14px;color:#999;padding-top:5px">注：(老人余额 + 本月月退费总金额 + 预交金 + 备用金 - 额外收费金额)为负数，不允许退住</div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="自动扣费" name="2">
                        <el-table v-loading="loadingGrid" :data="gridData" border show-summary style="width: 100%" max-height="300px">
                            <el-table-column property="startTime" :formatter="formatterTime1" label="收费开始时间"></el-table-column>
                            <el-table-column property="endTime" :formatter="formatterTime1" label="收费结束时间"></el-table-column>
                            <el-table-column property="money" sortable label="消费金额（元）"></el-table-column>
                            <el-table-column property="deductionType" label="收费类型">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.deductionType=='mul'">月固定费用</span>
                                    <span v-if="scope.row.deductionType=='one'">一次性固定费用</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="手动扣费" name="3">
                        <el-table v-loading="loadingGridHand" :data="handData" border show-summary style="width: 100%" max-height="300px">
                            <el-table-column property="deductionItemName" label="扣费项目"></el-table-column>
                            <el-table-column property="money" sortable label="扣费金额（元）"></el-table-column>
                            <el-table-column property="startTime" :formatter="formatterTime1" label="收费开始时间"></el-table-column>
                            <el-table-column property="endTime" :formatter="formatterTime1" label="收费结束时间"></el-table-column>
                            <el-table-column property="createTime" :formatter="formatterTime" label="扣费时间"></el-table-column>
                            <el-table-column property="remarks" label="备注"></el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
                <el-form :model="settleForm" ref="settleForm" style="margin-top:20px">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="额外收费金额" required>
                                <el-input-number v-model="settleForm.todayPrice" :min='0' :precision="2" :controls='false' @change="cutPriceInputShow=!cutPriceInputShow" class="inputMoneyNumber" style="width:100%">
                                </el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="备注">
                                <el-input type="textarea" v-model="settleForm.remarks" placeholder="请输入转房备注" rows="3" style="width:100%"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="settleDialog=false">取 消</el-button>
                    <el-button type="primary" :loading="settleSubLoading"  @click="settleSub">提交</el-button>
                </div>
            </el-dialog>
        </div>
        <GetElderly ref="myGetElderly" v-show="showModalGetElderly" v-on:closeGetElderly="closeGetElderly"  v-bind:ListBerth="ListBerth" v-on:getList="getList"></GetElderly>
        <ZiXuanEdit ref="myZiXuanEdit" v-show="showModalZiXuanEdit" v-on:closeZiXuanEdit="closeZiXuanEdit" v-bind:ListBerth="ListBerth" v-on:getList="getList"></ZiXuanEdit>
        <Leave ref="myLeave" v-show="showModalLeave" v-on:closeLeave="closeLeave" v-bind:ListBerth="ListBerth"   v-on:getList="getList"></Leave>
        <ZiXuanLeave ref="myZiXuanLeave" v-show="showModalZiXuanLeave" v-on:closeZiXuanLeave="closeZiXuanLeave" v-bind:ListBerth="ListBerth"   v-on:getList="getList"></ZiXuanLeave>
        <Detail ref="myDetail" v-show="showModalDetail" v-on:closeDetail="closeDetail"></Detail>

    </div>
</template>

<script>
    import ZiXuanEdit from "./ZiXuanEdit";
    import GetElderly from "./GetElderly";
    import Leave from "./Leave";
    import Detail from "./Detail";
    import Search from "@/components/Search";
    import Daterange from "@/components/Daterange";
    import {timeStr,nowTime,getNowTime,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Page",
        data() {
            return {
                loading: true,
                loadingGrid:false,
                loadingGridHand:false,
                gridData:[],
                balance:0,//余额
                deposit:0,//预交金
                imprest:0,//备用金
                sumPrice:0,
                sumPriceCharge:0,
                sumPriceSettle:0,
                menuButtonList:null,
                disabledAdd:true,
                disabledIn:true,
                disabledEdit:true,
                disabledSettlement:true,
                disabledLeave:true,
                disabledContract:true,
                disabledDetail:true,
                disabledType:true,
                settleSubLoading:false,
                checkinSubmitLoading:false,
                roomChangeSubmitLoading:false,
                checkinAutomatchFeeRelsList:[],
                
                //转房
                disabledRoomChange:true,
                dialogRoomChange:false,
                listBerthRC:[],
                props: {
                    emitPath:false,
                    value: 'berthCode',
                    label: 'number',
                    // 子层级字段名
                    children: 'listBerth'
                },
                roomChangeForm:{
                    newChangeBerthCode:'',
                    remarks:''
                },
                //退住
                activeName:"1",
                settleForm: {
                    todayPrice:0.00,
                    remarks:''
                },
                settleTime:nowTime,
                dialogSettleTime:false,
                handData:[],
                checkinCoupon:[],
                checkinTime:nowTime,
                statusValue:[[-1,'入住状态'],[0,'已预约'],[1,'入住中']],
                showModalAdd: false,
                showModalLeave: false,
                showModalZiXuanLeave:false,
                showModalDetail:false,
                datetimerangeValue:'',
                showModalEdit: false,
                showModalZiXuanEdit:false,
                checkinVisible:false,
                dialogFormVisible:false,
                cutPriceInputShow:false,
                today:'',
                lastDayOfMonth:'',
                priceMonthDeduction:'',
                settleDialog: false,
                elderlyBalance: '',
                cutPrice: 0.00,
                
                rules:{
                    totalMoney:[
                        { required: true, message: '请输入实际结算金额', trigger: 'blur' },
                        {
                            pattern: /^(\d?)+(\.\d{0,2})?$/,
                            message: '小数点后数字不能超过两位', trigger: 'blur'
                        },
                    ],
                    remarks:[
                        { required: true, message: '请输入备注', trigger: 'blur' },
                    ],
                    isRefund:[
                        { required: true, message: '请选择是否退款', trigger: 'blur' },
                    ],
                },
                showModalGetElderly: false,
                tableData: null,
                ListBerth: null,
                totalItems: 0,
                pageSize: 20,
                currentPage: 1,
                th: 0,
                checkinCouponDTOList: '',
                pickerOptions: {
                    disabledDate(time) {
                        var date = new Date();
                        var year = date.getFullYear();
                        var month = date.getMonth() + 1;
                        if (month >= 1 && month <= 9) {
                            month = "0" + month;
                        }
                        var currentdate = year.toString()  + month.toString();
 
                        var timeyear = time.getFullYear();
                        var timemonth = time.getMonth() + 1;
                        if (timemonth >= 1 && timemonth <= 9) {
                            timemonth = "0" + timemonth;
                        }
                        var timedate = timeyear.toString() + timemonth.toString();
                        return currentdate > timedate || time.getTime() > Date.now();

                        //return time.getTime() > Date.now() - 8.64e7;
                    },
                },
                pickerOptionsSettle:{
                    disabledDate(time) {
                        var today = new Date();
                        var year = today.getFullYear();
                        var month = today.getMonth() + 1;
                        var lastDay = new Date(year, month, 0);
                        var firstDay = new Date(year, month-1, 1);
                        return time.getTime() < firstDay || time.getTime() > lastDay
                    }
                },
                checkInfo:'',
                searchData:'',
                searchForm:{
                    elderlyName:'',
                    status:-1,
                    startTime:'',
                    endTime:'',
                }
            }
        },

        created() {
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight': function (val) {
                this.th = val;
            },
        },
        components: {
            GetElderly,Leave,ZiXuanEdit,Detail,Daterange,Search
        },
        methods: {
            
            DoubleAdd(num1,num2){
                let sumNum = num1+num2;
                // for(let i=0;i<this.checkinAutomatchFeeRelsList.length;i++){
                //     sumNum = sumNum+this.checkinAutomatchFeeRelsList[i].thisMonth
                // }
                return parseFloat(sumNum).toFixed(2);
            },
            getMenu(){
                this.searchData=[
                    {span:12,name:'老人姓名',value:'elderlyName',type:'input',clearable:true},
                    {span:12,name:'入住状态',value:'status',type:'select',options:this.statusValue,props:{label:'1',value:'0'}},
                    {span:24,name:'入住时间',width:495,value:'daterange',type:'slot'},
                ]
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            timefilter(dataTime){
                return timefilters(dataTime).slice(0,10);
            },
            dataChange(val){
                this.searchForm.startTime=val[0]
                this.searchForm.endTime=val[1]
            },
            //判断月份和当前日期大小
            getTimeSize(time){
                time = "2020-11"
                if(time!="" &&time!=null){
                    let time1=  time.replace('T',' ').slice(0,7);
                    let time2 = getNowTime("yyyy-MM");
                    let year1 = Number(time1.split("-")[0]);
                    let month1 = Number(time1.split("-")[1]);
                    let year2 = Number(time2.split("-")[0]);
                    let month2 = Number(time2.split("-")[1]);
                    if(year1>year2){
                        return time1+"(月底)";
                        
                    }else if(year1==year2){
                        if(month1>=month2){
                            return time1+"(月底)";
                        }else{
                            return "已过期";
                        }
                    }else{
                        return "已过期";
                    }
                }
            },
            checkInSub(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl + "Checkin/CheckinToElderlyAuto",
                    data:{
                        timeStr:timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        checkinCode:this.checkInfo.checkinCode,
                        cutPrice:this.cutPrice,
                        checkinTime:this.checkinTime
                    }
                }).then((response) => {
                    this.loading = false;
                    this.checkinSubmitLoading=false;
                    if (response.data.error == 0) {
                        this.checkinVisible = false;
                        this.getList()
                    } else if (response.data.error == 1) {
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //改变抹零金额
            cutPriceChange(){
                this.cutPriceInputShow=true
            },
            //转房
            handleRoomChange(){
                this.dialogRoomChange=true
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl + "Berth/ListBerthByRoomPriceMonth",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        berthCode:this.checkInfo.berthCode,
                    }
                }).then((response) => {
                    if (response.data.error == 0) {
                        var data=response.data.data
                        data=JSON.stringify(data).replace(/buildingCode/g,'berthCode')
                        this.listBerthRC=JSON.parse(data)
                    } else if (response.data.error == 1) {
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //转房提交
            roomChangeSubmit(){
                if(!this.roomChangeForm.newChangeBerthCode){
                    this.$message.error('请选择转房床位！')
                    return;
                }
                
                this.roomChangeSubmitLoading=true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl + "Checkin/RoomChangeAuto",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        newBerthCode:this.roomChangeForm.newChangeBerthCode,
                        checkinCode:this.checkInfo.checkinCode,
                        remarks:this.roomChangeForm.remarks
                    }
                }).then((response) => {
                    this.roomChangeSubmitLoading=false;
                    if (response.data.error == 0) {
                        this.$message.success('转房操作成功！')
                        this.dialogRoomChange=false
                        this.getList();
                    } else if (response.data.error == 1) {
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //结算前查询
            // settlefuc(){
            //     this.dialogSettleTime=false
            // },
            settlefucBefore(){
                this.dialogSettleTime=false
                this.settleDialog=true
                this.loadingGrid = true;
                this.loadingGridHand = true;
                var checkinCode=this.checkInfo.checkinCode
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl + "Checkin/SettleMoneyAuto",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        checkinCode:checkinCode,
                        settleTime:this.settleTime
                    }
                }).then((response) => {
                    this.loadingGrid = false;
                    this.loadingGridHand = false;
                    if (response.data.error == 0) {
                        // console.log(this.loadingGrid)
                        let checkinCharge = response.data.data;
                        this.gridData = checkinCharge.deductionRecordList;
                        this.handData = checkinCharge.deductionHandRecordList;
                        this.balance = checkinCharge.elderly.balance;
                        this.deposit = checkinCharge.elderly.deposit;
                        this.imprest = checkinCharge.elderly.imprest;
                        this.today = checkinCharge.today.replace('T',' ').slice(0,10);
                        this.lastDayOfMonth = checkinCharge.lastDayOfMonth.replace('T',' ').slice(0,10);
                        this.priceMonthDeduction = checkinCharge.priceMonthDeduction;
                        this.checkinAutomatchFeeRelsList = checkinCharge.checkinAutomatchFeeRelsList;
                        this.checkinCouponDTOList = checkinCharge.checkinCoupon;
                        this.sumPriceSettle = checkinCharge.sumPrice;
                        this.sumPrice = this.sumPriceSettle + this.deposit + this.imprest + this.balance;
                        this.sumPrice= this.sumPrice.toFixed(2);
                    } else if (response.data.error == 1) {
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            Leave(){
                if(this.checkInfo.chargeType!=2){
                    this.$refs.myLeave.init(this.checkInfo);
                    this.showModalLeave = !this.showModalLeave;
                }
                if(this.checkInfo.chargeType==2){
                    this.$refs.myZiXuanLeave.init(this.checkInfo);
                    this.showModalZiXuanLeave = !this.showModalZiXuanLeave;
                }
                
            },
            //退住结算提交
            settleSub(){
                if(this.balance==null){
                    this.$message("未查询到老人余额，系统异常");
                    return;
                }
                if(this.sumPrice<0){
                    let str = this.sumPrice+"";
                    this.$alert("余额不足，预计需补交"+str.substring(1)+"元");
                        return;
                }
                if(this.settleForm.todayPrice==undefined){
                    this.$message("请输入额外收费金额");
                    return;
                }
                this.settleSubLoading = true;
                this.loading = true;
                var data={
                    timeStr: timeStr,
                    sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                    staffCode: getStaffCode(),
                    checkinCode:this.checkInfo.checkinCode,
                    settleTime:this.settleTime
                }
                Object.assign(data,this.settleForm)
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl + "Checkin/RetreatSettleAuto",
                    data:data
                }).then((response) => {
                    this.settleSubLoading = false;
                    if (response.data.error == 0) {
                        this.settleDialog=false
                        this.settleTime=''
                        this.$refs.settleForm.resetFields();
                        this.getList();
                    } else if (response.data.error == 1) {
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getList() {
                this.loading = true;
                let data={
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode: getStaffCode(),
                    pageIndex:this.currentPage,
                    pageSize:this.pageSize,
                }
                Object.assign(data,this.searchForm)
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl + "Checkin/PageAuto",
                    data:data
                }).then((response) => {
                    this.loading = false;
                    this.disabledEdit=true
                    this.disabledIn=true
                    this.disabledSettlement=true
                    this.disabledLeave=true
                    this.disabledDetail = true;
                    this.disabledType = true;
                    if (response.data.error == 0) {
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    } else if (response.data.error == 1) {
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            handleEdit() {
                console.log(this.checkInfo.chargeType);
                if(this.checkInfo.chargeType!=2){
                    this.$refs.myEdit.init(this.checkInfo);
                    this.showModalEdit = !this.showModalEdit;
                }
                if(this.checkInfo.chargeType ==2){
                    this.$refs.myZiXuanEdit.init(this.checkInfo);
                    this.showModalZiXuanEdit = !this.showModalZiXuanEdit;
                }
            },
            //查看详情
            detail(){
                this.$refs.myDetail.init(this.checkInfo);
                this.showModalDetail = !this.showModalDetail;
            },
            CheckinTimeSubmit(){
                this.checkin();
            },
            //入住前接口
            checkin(){
                
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl + "Checkin/CheckinChargeDetails",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        checkinCode:this.checkInfo.checkinCode,
                        checkinTime:this.checkinTime,
                    }
                }).then((response) => {
                    if (response.data.error == 0) {
                        let checkinCharge = response.data.data;
                        this.today = checkinCharge.today.replace('T',' ').slice(0,10);
                        this.lastDayOfMonth = checkinCharge.lastDayOfMonth.replace('T',' ').slice(0,10);
                        this.priceMonthDeduction = checkinCharge.priceMonthDeduction;
                        this.sumPriceCharge = checkinCharge.sumPrice;
                        this.checkinAutomatchFeeRelsList = checkinCharge.checkinAutomatchFeeRelsList;
                        this.checkinCoupon=checkinCharge.checkinCoupon
                        this.dialogFormVisible = false;
                        this.checkinVisible=true;
                    } else if (response.data.error == 1) {
                        this.$message(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            }, 
            //入住确定
            checkinSubmit(){
                let mes = "";
                if(this.priceMonthDeduction+this.checkInfo.fixedFee>this.checkInfo.balance){
                    mes = "余额不足"
                }
                this.$confirm(this.checkInfo.elderlyName+mes+', 确认入住?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.checkinSubmitLoading=true;
                        this.checkInSub();
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });          
                });
            },   
           
            handleType(){
                console.log("转");
            },
            toggleModalAdd: function () {
                this.showModalGetElderly = !this.showModalGetElderly;
                this.$refs.myGetElderly.init();
            },
            closeGetElderly: function () {
                this.showModalGetElderly = !this.showModalGetElderly;
            },
            closeLeave: function () {
                this.showModalLeave = !this.showModalLeave;
            },
            closeDetail: function () {
                this.showModalDetail = !this.showModalDetail;
            },
            closeZiXuanLeave: function () {
                this.showModalZiXuanLeave = !this.showModalZiXuanLeave;
            },
            toggleModalEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },
            closeZiXuanEdit: function () {
                this.showModalZiXuanEdit = !this.showModalZiXuanEdit;
            },
            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.getList();
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            formatterTime1(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,10):null
            },
            formatterTime2(cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,7):null
            },
            updataTypeBefore(){
                this.$confirm('是否将'+this.checkInfo.elderlyName+'转为正式入住?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.updataType(this.checkInfo)
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });          
                });
            },
            updataType(row){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl + "Checkin/CheckinType",
                    data:{
                        timeStr:timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        checkinCode:row.checkinCode,
                    }
                }).then((response) => {
                    this.loading = false;
                    if (response.data.error == 0) {
                        this.checkinVisible = false;
                        this.getList()
                    } else if (response.data.error == 1) {
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row) {
                if (row.status == 0) {
                    return "已预约";
                }
                if (row.status == 1) {
                    return "入住中";
                }
                if (row.status == 2) {
                    return "已退住";
                }
                return "其它";
            },
            typeTitle(row) {
                if (row.type == 0) {
                    return "正式入住";
                }
                if (row.type == 1) {
                    return "试住";
                }
                if (row.type == 2) {
                    return "预约入住";
                }
                return "其它";
            },
            rowClick(row){
                this.disabledEdit=true
                this.disabledIn=true
                this.disabledSettlement=true
                this.disabledLeave=true
                this.disabledType=true
                this.disabledRoomChange=true
                this.checkInfo=row
                this.disabledDetail =false;
                if(row.status==1){
                    if(this.menuButtonList.indexOf("退住结算")!=-1){
                        this.disabledSettlement =false;
                    }
                    if(this.menuButtonList.indexOf("转房")!=-1){
                        this.disabledRoomChange =false;
                    }
                    if(this.menuButtonList.indexOf("正式入住")!=-1&&this.checkInfo.type==1){
                        this.disabledType=false
                    }
                    if(row.type==0){
                        if(this.menuButtonList.indexOf("编辑")!=-1){
                            this.disabledEdit =false;
                        }
                    }
                }   
                if(row.status==0){
                    // if(row.type==0){
                        if(this.menuButtonList.indexOf("编辑")!=-1){
                            this.disabledEdit =false;
                        }
                    // }
                    if(this.menuButtonList.indexOf("入住")!=-1){
                        this.disabledIn =false;
                    }
                }
            }

        }
    }
</script>

<style lang="scss" scoped>
    .checkIn /deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }
    .checkIn /deep/ .el-input.is-disabled .el-input__inner {
        background-color: #F5F7FA;
        border-color: #E4E7ED;
        color: #000;
        cursor: not-allowed;
        
    }
    .item{
        padding: 0px 20px;
    }
    .checkinCharge{
        padding: 10px;
        font-size: 17px;
        color: #666;
    }
    /deep/ .checkinTime .el-dialog__body{
        padding-bottom: 5px;
    }
    .inputMoneyNumber /deep/ .el-input__inner{
        text-align: left;
    }
    .eltabs /deep/ .el-tabs__content{
        height: 400px;
        // box-sizing: border-box;
        border: 1px solid rgb(235, 238, 245);
        overflow: auto;
    }
</style>